import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { EllipsisPipe } from '../../../pipes/ellipsis.pipe';
import { FormNumberIndicatorComponent } from '../form-number-indicator/form-number-indicator.component';
import { MatIconModule } from '@angular/material/icon';
import { HoverTooltipComponent } from '../../tooltips/hover-tooltip/hover-tooltip.component';
import { DialogTooltipComponent } from '../../tooltips/dialog-tooltip/dialog-tooltip.component';

@Component({
    selector: 'app-application-form-field',
    templateUrl: './application-form-field.component.html',
    styleUrl: './application-form-field.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        MatTooltipModule,
        HoverTooltipComponent,
        DialogTooltipComponent,
        MatIconModule,
        FormNumberIndicatorComponent,
        EllipsisPipe,
    ],
})
export class ApplicationFormFieldComponent {
    @Input() fieldNumber: string | undefined;
    @Input() ellipsisLength: number = 55;

    /*
     * The text displayed under the form field.
     */
    @Input() hintMessage: string = '';

    /*
     * The text displayed in the tooltip.
     * If hintMessage is not provided, this will be displayed under the form field.
     */
    @Input() tooltipMessage: string = '';

    @Input() showTooltipIcon: boolean = true;

    /*
     * If true the tooltip and form field will be displayed on one line.
     */
    @Input() inline: boolean = false;

    @Input() dialogTooltip: boolean = false;
    @Input() dialogTooltipTitle: string = 'Info';
    @Input() dialogWidth: string = '500px';

    getHintTextToDisplay() {
        return this.hintMessage || this.tooltipMessage;
    }
}
